import { gql } from "@apollo/client";
import { accessRecoveryFrom } from "../../../../../shared/graphql/accessRecovery";
import { bodyErrorsOf, entriesFrom, entriesOf } from "../../../../../shared/graphql/errorEntries";
import { httpStatusOf } from "../../../../../shared/graphql/sessionRefusal";
import type { TermsAcceptance } from "../terms/terms";

// Shapes verified against the PINNED Booking contract, not a moving ref.
//
// This said `origin/master`, which is how `apps/app` is validated and is wrong
// for this workspace: `quality:contracts` checks every document here against
// `booking-v1@1.4.0` at an immutable distribution coordinate, with the artifact
// digest verified. That pin is the point — a moving ref cannot tell you whether
// the schema you compiled against is the schema that shipped.

export const GET_AVAILABLE_SLOTS = ({"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableSlots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetAvailableSlotsInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAvailableSlots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slots"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endTime"},"arguments":[],"directives":[]}]}}]}}]}}]})










;

// booking-v1 1.20.0 (the payments flip branch's candidate): both writes take
// `clientCapabilities`. Its value is features/payments/capabilities.ts
// clientCapabilities(): `{ hostedCheckout: true }` with the payments gate
// open, and undefined (the variable omitted, as before 1.20) with it closed.
// Book never claims a capability it cannot complete.
export const CREATE_SLOT_HOLD = ({"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSlotHold"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSlotHoldInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientCapabilities"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientCapabilitiesInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSlotHold"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientCapabilities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientCapabilities"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"},"arguments":[],"directives":[]}]}}]}}]})














;

export const RELEASE_SLOT_HOLD = ({"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReleaseSlotHold"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"holdId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseSlotHold"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"holdId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"holdId"}}}],"directives":[]}]}}]})



;

export const CREATE_BOOKING = ({"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBookingInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientCapabilities"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientCapabilitiesInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientCapabilities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientCapabilities"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"revision"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"professionalId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creationSource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serviceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serviceName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"businessName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locationKind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addressDisplay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentTiming"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nextClientAction"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"awaitingDeadline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"checkoutUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"checkoutRef"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentPlanSummary"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appCollectableInCents"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remainingInPersonInCents"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"depositRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancellationPolicyType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewCopy"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"body"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statusLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"copyKey"},"arguments":[],"directives":[]}]}}]}}]}}]})
































































;

/**
 * `clientSecret` is deliberately NOT selected in the mutation above: since
 * booking-v1 1.20.0 it is retired (always null), and the payment page is
 * Stripe's hosted Checkout (`checkoutUrl`, `checkoutRef`), opened only through
 * features/payments/checkoutStart.ts with the payments gate open.
 *
 * Nor is `guestContact` ever sent with it. This mutation is the signed-in
 * client's: Backend takes the contact from the account and refuses one from a
 * signed-in caller. An anonymous guest books through the verified guest
 * checkout's own operation (features/guestCheckout/operations.ts); the
 * unverified anonymous commit was removed with the guest-verification OFF
 * build (f13, 2026-10-07).
 */

/**
 * What the client must do after a booking is created.
 *
 * THIS IS NOT ALWAYS "BOOKED". The shape depends on the professional's payment
 * mode and confirmation setting:
 *
 *   IN_PERSON_ONLY x auto    -> NONE
 *   IN_PERSON_ONLY x manual  -> AWAIT_PROFESSIONAL_ACCEPTANCE
 *   DEPOSIT/FULL   x manual  -> AWAIT_PROFESSIONAL_ACCEPTANCE
 *   DEPOSIT/FULL   x auto    -> COMPLETE_PAYMENT
 *
 * Our confirmation screen was designed for the first only. Treating the other
 * two as "You're booked" would put a promise on screen that the system has not
 * made — on the screen a client screenshots and comes back to. See Q34.
 */
export type NextClientActionType =
  | "NONE"
  | "AWAIT_PROFESSIONAL_ACCEPTANCE"
  | "COMPLETE_PAYMENT";

/**
 * The committed booking, exactly as the server describes it.
 *
 * Every field here is selected because something reads it — the outcome screen
 * renders it, or `isAuthorizedPilotOutcome` checks it. A field nobody reads is
 * a field that can be removed server-side without anyone noticing until it
 * 400s in production, which is how `averageRating` reached a client.
 */
export interface BookingOutcome {
  appointment: {
    /**
     * `booking-v1@1.4.0`, `Int!`. Typed as `number` rather than `number | null`
     * on purpose: the contract makes it non-null, so a null here is a broken
     * server response and must fail closed at the boundary rather than being
     * absorbed into an optional the ordering code then has to guess about.
     */
    revision: number;
    id: string;
    professionalId: string;
    /**
     * WHO CREATED THIS APPOINTMENT. `CLIENT` or `PROFESSIONAL` server-side.
     *
     * Open at the boundary for the same reason `status` is: a value added
     * server-side must not become a permissive fall-through here. The guard
     * requires `CLIENT` exactly, so an unrecognised value fails closed.
     */
    creationSource: string;
    serviceId: string;
    serviceName: string;
    startTime: string;
    endTime: string;
    timezone: string;
    /** Open at the boundary. `AppointmentStatus` is an enum server-side, but a
     *  value added there must not become a permissive fall-through here. */
    status: string;
    paymentMethod: string;
    paymentStatus: string | null;
    amountInCents: number;
    /**
     * RECEIPT FACTS, `booking-v1@1.7.0`. Every one is nullable, and null
     * means the fact is unavailable for this appointment: render the visible
     * receipt-unavailable state, never a fallback.
     *
     * Open strings at the boundary, like `status`: an enum member added
     * server-side must become "unavailable", not a guess. See
     * `features/receipt/receipt.ts`.
     */
    confirmationCode: string | null;
    businessName: string | null;
    locationKind: string | null;
    addressDisplay: string | null;
    paymentTiming: string | null;
  };
  nextClientAction: {
    /** An open string at the boundary: an unknown value must not be treated as NONE. */
    type: string;
    awaitingDeadline: string | null;
    /** booking-v1 1.20.0, with COMPLETE_PAYMENT: a bearer to Stripe's page. Only checkoutStartFrom may accept it. */
    checkoutUrl?: string | null;
    checkoutRef?: string | null;
  };
  paymentPlanSummary: {
    collectionMode: string;
    appCollectableInCents: number;
    remainingInPersonInCents: number;
    depositRequired: boolean;
    cancellationPolicyType: string;
  };
  /** Server-authored copy. Present, but see useBooking for why we do not render it blind. */
  reviewCopy: {
    headline: string;
    body: string;
    /**
     * THE STATUS PILL'S WORDS, AND THE SERVER OWNS THEM.
     *
     * Documented in as many words: "Server-owned appointment outcome label.
     * Mobile must not derive it from status." This screen used to derive the
     * pill from `appointment.status` through our own catalogue, which is
     * precisely what that sentence forbids — 1.1.0 froze DISTINCT copy for a
     * manual request versus an auto-confirmed booking, and a client deriving
     * its own label can silently disagree with the headline and body the same
     * response supplied.
     *
     * PRESENT AT `booking-v1@1.2.0`, INTRODUCED IN `1.1.0`. Worth stating
     * exactly, because the record around this field has been wrong twice: a
     * branch once selected it when no version we could resolve had it, and this
     * branch's first draft credited it to 1.2.0. Checked at both coordinates —
     * 1.1.0's schema (`07bc988a…`) has it; 1.2.0's additive delta is
     * `cancellationPolicyDisplay` plus the optional guest inputs.
     */
    statusLabel: string;
    ctaLabel: string | null;
    /** booking-v1 1.19.0. An OPEN string at the boundary (Backend's enum may grow). */
    copyKey?: string;
  };
}

/**
 * Does the server's own answer agree with itself?
 *
 * Ported from the September pilot branch, which got this right: the outcome
 * copy is the server's to write, but Web can still refuse to show a success
 * whose machine facts contradict it. A booking that says IN_PERSON_ONLY while
 * also claiming money is collectable in-app is not a booking we can describe,
 * and guessing which half is true is how a client gets told they owe nothing
 * when they owe sixty dollars.
 *
 * `creationSource` IS NOW CHECKED, and the history matters. A previous branch
 * gated on it before it existed: the whole query 400d, and had the field merely
 * been dropped from the response the guard would have rejected every legitimate
 * booking — a guard keyed on something that cannot arrive fails closed on
 * everything, which looks exactly like the feature being broken. It is present
 * at `booking-v1@1.2.0` — `AppointmentCreationSource!`, non-null — and was
 * introduced in `1.1.0`, so the gate is now real rather than a self-inflicted
 * outage.
 *
 * What it buys: this surface is the CLIENT booking flow, and the appointment it
 * just created must be one the client created. A `PROFESSIONAL` value coming
 * back from our own `createBooking` means the response describes something other
 * than what this screen is about to claim happened. Required to equal `CLIENT`
 * exactly, so an enum member added server-side fails closed rather than falling
 * through to a success screen.
 *
 * The pairing at the end is the point. September is IN_PERSON_ONLY and either
 * auto-confirms or waits for the professional; any other combination — most of
 * all a CONFIRMED that also wants payment — is a contradiction, not a state.
 */
export function isAuthorizedPilotOutcome(
  outcome: BookingOutcome | null | undefined
): outcome is BookingOutcome {
  if (!outcome) return false;
  const { appointment: appt, paymentPlanSummary: plan, reviewCopy } = outcome;

  if (
    appt.creationSource !== "CLIENT" ||
    appt.paymentMethod !== "in_person" ||
    (appt.paymentStatus !== "none" && appt.paymentStatus !== null) ||
    plan.collectionMode !== "IN_PERSON_ONLY" ||
    plan.appCollectableInCents !== 0 ||
    plan.depositRequired !== false ||
    // What is owed at the appointment must equal what the appointment costs.
    plan.remainingInPersonInCents !== appt.amountInCents ||
    // booking-v1@1.7.0: the terms frozen at booking. The pilot's pay-later path
    // is DUE_AT_APPOINTMENT; any OTHER stated timing contradicts IN_PERSON_ONLY
    // and is not an outcome we may describe. Null is an unavailable receipt
    // fact, shown as such on the outcome screen, not a contradiction.
    (appt.paymentTiming !== null && appt.paymentTiming !== "DUE_AT_APPOINTMENT") ||
    reviewCopy.headline.trim().length === 0 ||
    reviewCopy.body.trim().length === 0 ||
    // The pill's words come from here and there is no local fallback, so an
    // empty label would render a blank chip beside a success headline. Held to
    // the same non-empty standard as the headline and body it sits with.
    reviewCopy.statusLabel.trim().length === 0
  ) {
    return false;
  }

  return (
    (appt.status === "CONFIRMED" && outcome.nextClientAction.type === "NONE") ||
    (appt.status === "REQUESTED" &&
      outcome.nextClientAction.type === "AWAIT_PROFESSIONAL_ACCEPTANCE")
  );
}

/**
 * AN APP-PAID BOOKING'S ANSWER, PAIRED EXACTLY (booking-v1 1.20.0; the
 * payments flip branch). Read ONLY with the payments gate open (`interpret`);
 * with it closed every such answer stays unauthorized, as before.
 *
 * Backend's written shapes (v1.1.0 139a2ed8f, createBookingResponse.ts; the
 * Web Director's rulings, 2026-10-21). On a first answer AND every same-key
 * replay: paymentMethod in_app, the plan as first stored, paymentTiming by
 * mode. The client-visible outcome is `reviewCopy.copyKey`, rebuilt from live
 * state. The pairing is copyKey + status + paymentStatus + the next action,
 * exactly; anything else is null, so the caller fails closed to "couldn't
 * confirm".
 *
 * | kind             | status    | paymentStatus             | next action                   | copyKey |
 * |------------------|-----------|---------------------------|-------------------------------|---------|
 * | pay              | REQUESTED | pending                   | COMPLETE_PAYMENT              | PAYMENT_REQUIRED_DEPOSIT / _FULL, by mode |
 * | request          | REQUESTED | none                      | AWAIT_PROFESSIONAL_ACCEPTANCE | REQUEST_SENT (first) / REQUESTED (replay) |
 * | settling         | REQUESTED | pending or paid (*)       | NONE                          | PAYMENT_SETTLING |
 * | paid             | CONFIRMED | paid                      | NONE                          | BOOKED_PAID (nothing left) / BOOKED_PAID_BALANCE_IN_PERSON (a balance left) |
 * | expired          | EXPIRED   | failed                    | NONE                          | EXPIRED (after the expiry job: no booking, nothing charged) |
 * | expired-refund   | EXPIRED   | refund_initiated/refunded | NONE                          | EXPIRED (a LATE payment being refunded: never "no payment") |
 * | checkout-expired | REQUESTED | pending                   | NONE                          | CHECKOUT_EXPIRED (definite since Backend 2058dcc4e: CHECKOUT_EXPIRED_REPLAY_IS_DEFINITE) |
 *
 * (*) A split second between the webhook's two writes; both are settling, and
 * a booking exists.
 *
 * PAYMENT_FAILED is unreachable for auto-confirm (Backend), so it has no row
 * and fails closed. A declined card under hosted Checkout stays "pay" (no
 * state change).
 *
 * The same self-consistency as the in-person guard, for every kind:
 * - client-created, paid in app;
 * - a mode Book can describe: DEPOSIT_REQUIRED (a deposit, part or all of the
 *   price) or FULL_PREPAY_REQUIRED (all of it, no deposit);
 * - the server's halves adding up to the price;
 * - the frozen paymentTiming, when stated, matching the mode;
 * - non-empty server copy.
 * The charge's currency is not on this answer: v1.1 charges USD only, and the
 * amounts Book states (Review's line, /a's money) carry or assume USD.
 */
export type PaidOutcomeKind = "pay" | "request" | "settling" | "paid" | "expired" | "expired-refund" | "checkout-expired";

const DEPOSIT = "DEPOSIT_REQUIRED";
const FULL = "FULL_PREPAY_REQUIRED";

export function paidOutcomeKind(outcome: BookingOutcome | null | undefined): PaidOutcomeKind | null {
  if (!outcome) return null;
  const { appointment: appt, paymentPlanSummary: plan, reviewCopy, nextClientAction: action } = outcome;
  const whole = (value: unknown): value is number => typeof value === "number" && Number.isSafeInteger(value);
  const mode = plan.collectionMode;

  if (
    appt.creationSource !== "CLIENT" ||
    appt.paymentMethod !== "in_app" ||
    (mode !== DEPOSIT && mode !== FULL) ||
    !whole(appt.amountInCents) ||
    !whole(plan.appCollectableInCents) ||
    !whole(plan.remainingInPersonInCents) ||
    plan.appCollectableInCents <= 0 ||
    plan.appCollectableInCents > appt.amountInCents ||
    plan.appCollectableInCents + plan.remainingInPersonInCents !== appt.amountInCents ||
    (mode === DEPOSIT && plan.depositRequired !== true) ||
    (mode === FULL && (plan.depositRequired !== false || plan.remainingInPersonInCents !== 0)) ||
    (appt.paymentTiming !== null &&
      appt.paymentTiming !== (mode === DEPOSIT ? "DEPOSIT_IN_APP_REMAINDER_AT_APPOINTMENT" : "FULL_AMOUNT_IN_APP")) ||
    reviewCopy.headline.trim().length === 0 ||
    reviewCopy.body.trim().length === 0 ||
    reviewCopy.statusLabel.trim().length === 0
  ) {
    return null;
  }

  const pairs = (status: string, payment: readonly string[], next: string, keys: readonly string[]) =>
    appt.status === status && payment.includes(appt.paymentStatus as string) && action.type === next && keys.includes(reviewCopy.copyKey as string);

  if (pairs("REQUESTED", ["pending"], "COMPLETE_PAYMENT", [mode === DEPOSIT ? "PAYMENT_REQUIRED_DEPOSIT" : "PAYMENT_REQUIRED_FULL"])) return "pay";
  if (pairs("REQUESTED", ["none"], "AWAIT_PROFESSIONAL_ACCEPTANCE", ["REQUEST_SENT", "REQUESTED"])) return "request";
  if (pairs("REQUESTED", ["pending", "paid"], "NONE", ["PAYMENT_SETTLING"])) return "settling";
  if (pairs("CONFIRMED", ["paid"], "NONE", [plan.remainingInPersonInCents > 0 ? "BOOKED_PAID_BALANCE_IN_PERSON" : "BOOKED_PAID"])) return "paid";
  if (pairs("EXPIRED", ["failed"], "NONE", ["EXPIRED"])) return "expired";
  if (pairs("EXPIRED", ["refund_initiated", "refunded"], "NONE", ["EXPIRED"])) return "expired-refund";
  if (pairs("REQUESTED", ["pending"], "NONE", ["CHECKOUT_EXPIRED"])) return "checkout-expired";
  return null;
}

export interface CreateBookingData {
  createBooking: BookingOutcome;
}

/**
 * THE VARIABLES `createBooking` TAKES, TYPED SO THE KEY CANNOT BE FORGOTTEN.
 *
 * `idempotencyKey` is `ID!` in `booking-v1@1.4.0`, and GraphQL document
 * validation CANNOT catch its absence: the input arrives as a single `$input`
 * variable, so the document is valid whatever the object turns out to contain.
 * Measured — the 1.4 pin accepts the old document unchanged. The only place
 * omission can be caught before runtime is the type system, so this is the
 * check, and `useMutation` is parameterised with it.
 *
 * `readonly` and the absence of an index signature are both load-bearing: the
 * value handed here is the FROZEN attempt input, and typing it mutably would
 * invite a caller to adjust one field before a resend — same key, different
 * arguments, which the server refuses as `IDEMPOTENCY_CONFLICT`.
 */
export interface CreateBookingVariables {
  readonly input: {
    readonly holdId: string;
    /** REQUIRED. See `features/booking/attempt.ts` for why it is never regenerated. */
    readonly idempotencyKey: string;
    /**
     * booking-v1 1.13+. Present exactly when Terms are published and the
     * person accepted them; an exact echo of what Review displayed. Outside
     * the idempotency fingerprint, so a re-ask may change it under the same
     * key (see `features/booking/attempt.ts`).
     */
    readonly termsAcceptance?: TermsAcceptance;
  };
  /** booking-v1 1.20.0: features/payments/capabilities.ts clientCapabilities(); undefined while the gate is closed. */
  readonly clientCapabilities?: { readonly hostedCheckout: true };
}


export interface TimeSlot {
  /** ISO 8601 UTC. Rendered in the PROFESSIONAL's timezone, never the visitor's. */
  startTime: string;
  endTime: string;
}

export interface AvailableSlotsData {
  getAvailableSlots: {
    timezone: string;
    date: string;
    /**
     * ONLY the open slots. There is no "taken" flag on the wire.
     *
     * Worth knowing, because the design draws crossed-out unavailable times
     * (docs/design/lura-book-v1, StepTime) and we cannot render them: a taken
     * slot is simply absent. Recorded rather than faked — inventing a
     * crossed-out row would mean guessing which times a professional works,
     * and being wrong about it looks like a bug in their calendar.
     */
    slots: TimeSlot[];
  };
}

export interface SlotHold {
  id: string;
  startTime: string;
  endTime: string;
  /**
   * When the server will drop this hold. AUTHORITATIVE.
   *
   * The countdown renders from this value rather than from a local timer
   * started at acquisition. Product was explicit that a re-hold RESUMES the
   * existing expiration and must not restart it, so a timer seeded on the
   * client would show a fresh ten minutes for a hold that has two left.
   */
  expiresAt: string;
}

export interface CreateSlotHoldData {
  createSlotHold: SlotHold;
}

/**
 * The two 409s, which mean opposite things.
 *
 * They differ ONLY in `extensions.code` — both carry HTTP 409 — so anything
 * branching on status conflates "wait a moment" with "that time is gone".
 */
export type SlotConflict = "SLOT_HELD" | "SLOT_TAKEN" | "NOT_FOUND" | null;

interface GraphQLishError {
  /**
   * Apollo Client 3's property. Kept ONLY so an older shape still parses; it
   * does not exist on anything Apollo 4 raises, which is exactly how this
   * function came to be broken in production while its unit test passed.
   */
  graphQLErrors?: readonly { extensions?: { code?: unknown } }[];
  /** Apollo 4 `CombinedGraphQLErrors` — an HTTP 200 carrying a GraphQL error. */
  errors?: readonly { extensions?: { code?: unknown } }[];
  /**
   * Apollo 4 `ServerError` — a non-2xx response. The body is NOT parsed for
   * you: it arrives as the raw text, so the code has to be dug out of it. This
   * is the shape our backend actually produces, because it answers a slot
   * conflict with HTTP 409.
   */
  bodyText?: unknown;
  cause?: { extensions?: { code?: unknown } };
}

/**
 * WHY `createBooking` NEEDS ITS OWN CLASSIFIER, and cannot reuse the hold's.
 *
 * `createSlotHold` answers a lost slot with `SLOT_TAKEN`. `createBooking`
 * DOES NOT — the published contract says so in as many words: "SLOT_UNAVAILABLE:
 * the slot was taken while the hold was live. This is the real 'lost the slot'
 * outcome — the mutation does NOT raise SLOT_TAKEN."
 *
 * This surface checked for `SLOT_TAKEN` on commit anyway. That check could
 * never fire, so every genuinely lost slot fell through to the generic failure,
 * whose copy tells the client "your time is still held" — about a slot that
 * someone else now owns. The stub in our own e2e answered `SLOT_TAKEN` because
 * that is what we asked it for, which is precisely why a stub cannot find this.
 *
 * THE THREE-WAY SPLIT the classifier exists to make, which matters more than
 * any individual code:
 *
 *   TYPED REFUSAL   the server answered with a code. Whatever it says, the
 *                   request REACHED the server and was decided. Safe to state
 *                   an outcome.
 *   DEFINITE FAIL   the server answered, and its answer means no booking was
 *                   made. Safe to say nothing was booked, safe to offer retry.
 *   AMBIGUOUS LOSS  no answer at all. The request may have committed. It is NOT
 *                   safe to say nothing was booked, and it is not safe to
 *                   retry blindly.
 *
 * The default is AMBIGUOUS, and only evidence moves a failure out of it. An
 * unrecognised code still counts as evidence — the server processed the request
 * and refused it — so an unknown code is `refused`, not `lost`. What lands in
 * `lost` is the case where we hold no server response whatsoever.
 */
export type BookingFailure =
  /** `SLOT_UNAVAILABLE` — someone else took the slot while the hold was live. */
  | { kind: "slot-unavailable" }
  /** `NOT_FOUND` — the hold vanished, expired, or was never ours. */
  | { kind: "hold-gone" }
  /** `CONFLICT` — the professional changed payment settings mid-booking. The
   *  contract says to retry, and warns the price or deposit may now differ. */
  | { kind: "settings-changed" }
  /** `FORBIDDEN` + `CLIENT_ACCOUNT_REQUIRED` — this professional takes bookings
   *  only from signed-in accounts. Outside the September cohort entirely. */
  | { kind: "account-required" }
  /** Guest-contact validation. The ONLY stage carrying `detailCode`; reading
   *  that field off any other stage yields undefined. */
  | { kind: "contact-invalid"; detailCode: string | null; field: string | null }
  /** `BOOKING_ALREADY_CONFIRMED` / `BOOKING_CONFIRMATION_PENDING`. The contract
   *  is explicit: the booking exists, show it rather than retrying. Out of
   *  cohort in September (Stripe-only), handled so it can never become a
   *  silent duplicate if that ever changes. */
  | { kind: "already-booked"; appointmentId: string | null }
  /** `FORBIDDEN` + a payment-mode `detailCode`: this professional cannot be
   *  booked this way at all. `GUEST_PAYMENT_MODE_NOT_AVAILABLE` (booking-v1
   *  1.11: a guest booking an app-paid professional) or
   *  `IN_APP_PAYMENTS_NOT_AVAILABLE` (Backend's payment admission, closed in
   *  Production). Refused before any write, and no retry can succeed. */
  | { kind: "payment-mode-unavailable"; detailCode: string }
  /**
   * PAYMENT_TERMS_CHANGED (payments v1.1.0; Backend plan rev 3 §11.3 item 8):
   * the professional's payment terms changed after the hold. `INVALID_STATE`
   * (the STALE pattern), recorded on the key's receipt, nothing booked: the
   * client re-reads the terms and starts again with a fresh hold and key.
   */
  | { kind: "payment-terms-changed" }
  /**
   * 422 INVALID_INPUT + PAYMENT_MODE_NOT_SUPPORTED_BY_CLIENT (rev 3, P1): the
   * professional takes payment in the app and this client did not claim
   * `hostedCheckout`. Refused before any hold or commit. Its own kind, beside
   * `payment-mode-unavailable` (rc.13 plan §2.4).
   */
  | { kind: "payment-client-unsupported" }
  /**
   * Backend refused the Terms acceptance (booking-v1 1.13+). A pre-write
   * refusal of the INPUT: the Terms check runs after the replay pre-read and
   * before the strategy's write (createBooking step 5c), and termsAcceptance
   * is outside the idempotency fingerprint. So the re-ask keeps the SAME key
   * (and, for a guest, the same proof), and a booking the key already
   * committed still replays. `stale` / `required`: re-read, show, untick, ask
   * again. `unavailable`: the "couldn't load the terms" frame.
   */
  | { kind: "terms"; refusal: TermsRefusal }
  /** A typed refusal we do not have specific copy for. Still DEFINITE. */
  | { kind: "refused"; code: string }
  /** No server answer. May or may not have committed. Never claim either. */
  | { kind: "lost" };

/**
 * The `FORBIDDEN` detail codes that mean "this professional cannot be booked
 * this way", at the hold or at the booking. Typed so the screens can stop
 * offering retries that cannot succeed; Product's wording for them lands
 * separately.
 */
export const PAYMENT_MODE_REFUSALS: ReadonlySet<string> = new Set([
  "GUEST_PAYMENT_MODE_NOT_AVAILABLE",
  "IN_APP_PAYMENTS_NOT_AVAILABLE",
]);

/** The payment-mode refusal a hold or booking error carries, or null. */
export function paymentModeRefusalFrom(error: unknown): string | null {
  // A code on a 408 or a 5xx is a transport answer, not a server decision
  // (the same rule bookingFailureFrom applies first; review A4a).
  if (ambiguousTransportStatus(error) !== null) return null;
  for (const { code, ext } of entriesFrom(error)) {
    if (code === "FORBIDDEN" && typeof ext.detailCode === "string" && PAYMENT_MODE_REFUSALS.has(ext.detailCode)) {
      return ext.detailCode;
    }
  }
  return null;
}

/**
 * THE ONLY CODES THAT MAY CLAIM "NOTHING WAS BOOKED".
 *
 * An explicit allowlist, and the default is ambiguity. This replaces a
 * heuristic that asked "did the server answer at all?" and treated any answer
 * as proof the booking did not happen. That is unsafe, and the Web Director
 * was right to reject it: a 500 means the server DID process the request, and
 * an appointment may well have been written before response construction
 * failed. An unknown code means the server decided something we cannot read —
 * not that it decided nothing.
 *
 * Every entry below is documented by the contract as a state in which no
 * appointment exists: the eligibility refusals raised BEFORE the write, and
 * the transaction aborts, which by definition rolled back.
 *
 * Deliberately NOT here, and therefore ambiguous: INTERNAL_SERVER_ERROR, any
 * 5xx, timeouts, connection loss, a missing payload, a malformed response, and
 * any code this list does not name. Adding a code here is a claim that the
 * server could not have written an appointment. Make that claim only with the
 * contract text in front of you.
 */
const DEFINITELY_NO_APPOINTMENT: ReadonlySet<string> = new Set([
  // Eligibility, raised before the write.
  "UNAUTHENTICATED",
  "FORBIDDEN",
  "INVALID_INPUT",
  // Transaction aborts. The contract raises these INSIDE the booking
  // transaction, which means it rolled back.
  "SLOT_UNAVAILABLE",
  "NOT_FOUND",
  "CONFLICT",
  // `STRIPE_NOT_READY` is raised at Step A, BEFORE the appointment id is
  // allocated — verified in `depositAutoConfirm.ts` at the pinned distribution
  // commit. No appointment can exist.
  "STRIPE_NOT_READY",
]);

/*
 * WHY `CHECKOUT_EXPIRED` AND `CHECKOUT_ALREADY_STARTED` ARE NOT ON THAT LIST.
 *
 * They were, on the reasoning that they "describe a checkout, not a created
 * appointment". Reading the backend source at the pinned commit shows that is
 * false. Both are thrown inside `if (hd.checkoutAppointmentId)` — the branch
 * entered only when an appointment id has ALREADY been allocated and persisted
 * onto the hold:
 *
 *   src/services/bookingCreation/depositAutoConfirm.ts
 *   src/services/bookingCreation/fullPrepayAutoConfirm.ts
 *
 * So an appointment demonstrably exists, and treating either as "nothing was
 * booked" would tell a client the opposite of the truth and offer them a retry.
 * They fall through to ambiguous, which is what the evidence supports.
 *
 * This is the second time a member of that allowlist was added from a comment
 * rather than from the source. Every entry is a claim the server COULD NOT have
 * written an appointment; read the resolver before making it.
 */

/*
 * TRANSPORT AMBIGUITY OUTRANKS EVERY BODY CODE.
 *
 * `entriesFrom` digs codes out of `bodyText`, which exists only on a NON-2xx
 * response — and the classifier below then trusted those codes without ever
 * looking at the status they arrived with. `502 + CONFLICT` therefore resolved
 * to `settings-changed`: a definite "nothing was booked, the professional
 * changed their payment settings, try again", assembled out of a body our
 * origin may never have written.
 *
 * The test `serverError(500, "INTERNAL_SERVER_ERROR") -> lost` passed through
 * all of this. It proved the ALLOWLIST worked, because INTERNAL_SERVER_ERROR is
 * not on it. It could not prove the status was read, because the status was
 * never read. Swapping its code for CONFLICT is what exposes the hole.
 *
 * WHY THESE STATUSES:
 *
 *   408  The request timed out. We are not holding the answer to the request we
 *        sent, whatever else we are holding, and the origin may still be
 *        finishing it.
 *   5xx  Either the origin failed after reaching the resolver — precisely the
 *        case where an appointment may already be written — or an intermediary
 *        answered on its own behalf, in which case the body is not ours. A
 *        gateway may return any body it likes with a 502.
 *
 * WHY NOT EVERY 4xx: our origin answers typed refusals WITH 4xx — 409 for both
 * slot conflicts and for CONFLICT, 422 for validation. Those are the server's
 * decision, arriving exactly as designed, and making them ambiguous would erase
 * every specific recovery screen this flow has. 408 is the one 4xx that reports
 * no decision was received.
 *
 * Read from the error object only, NEVER from `extensions.http.status`: that
 * field is written by whoever produced the body, and the entire point of this
 * rule is that the body may not have come from our origin.
 *
 * WHERE THIS RULE IS BLIND, so the next reader does not assume it is total.
 *
 * Apollo 4 sends `accept: application/graphql-response+json, application/json`,
 * and its `parseResponse` skips the `status >= 300` throw for the GraphQL
 * content type — so a non-2xx answered as `graphql-response+json` arrives as
 * `CombinedGraphQLErrors`, with no `statusCode` and no `bodyText`, and this
 * function sees nothing to act on.
 *
 * That is not reachable as a defect today, and each half of the reason is
 * separate: the gateway case this rule exists for does not speak GraphQL
 * content types at all, our origin answers typed refusals with 4xx (which are
 * deliberately excluded anyway), and a 5xx from our origin carries
 * INTERNAL_SERVER_ERROR — not on the allowlist, so it lands in `lost` by the
 * default rather than by this rule. Raised in review; recorded rather than
 * papered over, because all three of those are properties of the CURRENT
 * backend and any one of them could change.
 */
const REQUEST_TIMEOUT = 408;

export function ambiguousTransportStatus(error: unknown): number | null {
  // `statusCode` is Apollo 4's shortcut on ServerError and ServerParseError;
  // `response.status` is the fetch Response it shortcuts to. Both are read so a
  // partially-constructed error still reports the status it does have
  // (shared/graphql/sessionRefusal.ts `httpStatusOf`, the same read).
  const status = httpStatusOf(error);
  if (status === null) return null;
  return status === REQUEST_TIMEOUT || status >= 500 ? status : null;
}

/** How Backend refused a Terms acceptance. See `features/terms/terms.ts`. */
export type TermsRefusal = "stale" | "required" | "unavailable";

/**
 * IS THIS ERROR BACKEND REFUSING THE TERMS, AND HOW? (booking-v1 1.13+,
 * client-v1 1.2+; the same codes on `createBooking` and `account.create`.)
 *
 * TERMS_UNAVAILABLE travels as SERVICE_NOT_CONFIGURED on a 503, and the
 * transport rule above reads a code on a 5xx as a transport answer, because a
 * gateway can put any body on a 502. The exception is the 503 it is SENT on
 * and nothing wider: the same narrow exception `guestBookingFailureFrom` makes
 * for GUEST_BOOKING_UNAVAILABLE. A gateway does not invent
 * `detailCode: TERMS_UNAVAILABLE`, and Backend raises it before any write
 * (createBooking step 5c, after the replay pre-read and before the strategy;
 * account.create before the user document). A 502, a 504, a 408, or a request
 * asking to be retried is still a transport answer, and so not this.
 *
 * TERMS_STALE and TERMS_ACCEPTANCE_REQUIRED are INVALID_INPUT (422) naming
 * `termsAcceptance`, and are held to the transport rule like any other code.
 */
export function termsRefusalFrom(error: unknown): TermsRefusal | null {
  if (accessRecoveryFrom(error)?.accessRecovery === "RETRY_PRESERVING_SESSION") return null;
  const status = ambiguousTransportStatus(error);
  for (const { code, ext } of entriesFrom(error)) {
    if (code === "SERVICE_NOT_CONFIGURED" && ext.detailCode === "TERMS_UNAVAILABLE") {
      if (status === null || status === 503) return "unavailable";
      continue;
    }
    if (status !== null) continue;
    if (code === "INVALID_INPUT" && ext.detailCode === "TERMS_STALE") return "stale";
    if (code === "INVALID_INPUT" && ext.detailCode === "TERMS_ACCEPTANCE_REQUIRED") return "required";
  }
  return null;
}

/** Classify a rejected `createBooking`. See BookingFailure for the reasoning. */
export function bookingFailureFrom(error: unknown): BookingFailure {
  // The new recovery contract says the session remains usable, not that a
  // booking mutation was never received. Keep this write on the conservative
  // lost/recheck path: the only permitted replay is the existing user-driven,
  // idempotency-keyed check in useBooking.
  if (accessRecoveryFrom(error)?.accessRecovery === "RETRY_PRESERVING_SESSION") {
    return { kind: "lost" };
  }

  // Before the transport rule, for the one 503 it names (see termsRefusalFrom).
  const terms = termsRefusalFrom(error);
  if (terms !== null) return { kind: "terms", refusal: terms };

  // FIRST, before a single code is read. A recognised code arriving on a 408 or
  // a 5xx is not evidence the transaction rolled back — see above.
  if (ambiguousTransportStatus(error) !== null) return { kind: "lost" };

  const entries = entriesFrom(error);

  for (const { code, ext } of entries) {
    switch (code) {
      case "SLOT_UNAVAILABLE":
        return { kind: "slot-unavailable" };
      case "NOT_FOUND":
        return { kind: "hold-gone" };
      case "CONFLICT":
        return { kind: "settings-changed" };
      case "INVALID_STATE":
        // The contract's ONE form (Backend, settled 2026-10-17): INVALID_STATE
        // + PAYMENT_TERMS_CHANGED, definite.
        if (ext.detailCode === "PAYMENT_TERMS_CHANGED") return { kind: "payment-terms-changed" };
        // Any other INVALID_STATE is not known to be pre-write: "lost".
        break;
      case "BOOKING_ALREADY_CONFIRMED":
      case "BOOKING_CONFIRMATION_PENDING":
        return {
          kind: "already-booked",
          appointmentId: typeof ext.appointmentId === "string" ? ext.appointmentId : null,
        };
      case "IDEMPOTENCY_CONFLICT":
        /*
         * A BOOKING EXISTS UNDER THIS KEY, made by a DIFFERENT request.
         * Backend raises it only from a receipt already on file
         * (bookingIdempotency.ts, assertSameBookingRequest), so it is never
         * "nothing was booked", and a "try again" under a new key would make
         * a second booking (security re-audit, rc.8). Named here so nobody
         * adds it to DEFINITELY_NO_APPOINTMENT: it is the may-have-gone-through
         * state, whose only action is the Check under the ORIGINAL key.
         */
        return { kind: "lost" };
      case "FORBIDDEN":
        // `detailCode` distinguishes the account gate from other refusals.
        if (ext.detailCode === "CLIENT_ACCOUNT_REQUIRED") return { kind: "account-required" };
        if (typeof ext.detailCode === "string" && PAYMENT_MODE_REFUSALS.has(ext.detailCode)) {
          return { kind: "payment-mode-unavailable", detailCode: ext.detailCode };
        }
        return { kind: "refused", code: "FORBIDDEN" };
      case "INVALID_INPUT": {
        if (ext.detailCode === "PAYMENT_MODE_NOT_SUPPORTED_BY_CLIENT") return { kind: "payment-client-unsupported" };
        const args = Array.isArray(ext.invalidArgs) ? (ext.invalidArgs as unknown[]) : [];
        // Backend (b77e6beb, 2026-09-23) names the path `guestContact.fullName`;
        // earlier fixtures wrote `input.guestContact.…`. Both are the contact.
        // The object or one of ITS fields only: `guestContactVerificationId`
        // shares the prefix and is the proof, not the contact, so it must never
        // send a guest back to Details.
        const isContactPath = (arg: string) =>
          ["guestContact", "input.guestContact"].some((base) => arg === base || arg.startsWith(`${base}.`));
        const contactArg = args.find((arg) => typeof arg === "string" && isContactPath(arg));
        if (contactArg) {
          return {
            kind: "contact-invalid",
            detailCode: typeof ext.detailCode === "string" ? ext.detailCode : null,
            field: typeof contactArg === "string" ? contactArg : null,
          };
        }
        return { kind: "refused", code: "INVALID_INPUT" };
      }
      default:
        // A code we recognise as definite, but have no specific screen for.
        if (typeof code === "string" && DEFINITELY_NO_APPOINTMENT.has(code)) {
          return { kind: "refused", code };
        }
        // A code we do NOT recognise. The server decided something; we cannot
        // read what. It may have written an appointment. Fall through.
        break;
    }
  }

  // THE DEFAULT IS "WE DO NOT KNOW", and nothing but the allowlist above moves
  // a failure out of it. Unknown codes, INTERNAL_SERVER_ERROR, 5xx, timeouts,
  // dropped connections, unparseable bodies and missing payloads all land here.
  return { kind: "lost" };
}

/**
 * Read the typed conflict out of an Apollo error.
 *
 * Deliberately does not fall back to a status code. If the shape changes and
 * the code stops arriving, this returns null and the caller shows a generic
 * failure — which is honest — rather than guessing from 409 and telling
 * someone to retry a slot that is permanently gone.
 */
export function slotConflictFrom(error: unknown): SlotConflict {
  if (!error || typeof error !== "object") return null;

  // The same precedence rule as `bookingFailureFrom`, for the same reason one
  // function down: a 502 carrying SLOT_TAKEN would take a time off the screen
  // permanently on the word of a body the origin may not have written. Both
  // real conflicts arrive as 409 and are untouched.
  //
  // NOT NAMED BY THE REVIEW — the finding was raised against the commit
  // classifier. It is the identical defect here, so it is fixed here too rather
  // than left for the next reader to rediscover.
  if (ambiguousTransportStatus(error) !== null) return null;

  const candidate = error as GraphQLishError;

  // The conflict code can arrive in three shapes and this must read all of
  // them. `SLOT_HELD` and `SLOT_TAKEN` are both HTTP 409 and mean OPPOSITE
  // things — "wait a moment" versus "that one is gone" — so failing to read the
  // code does not degrade the message, it replaces both with a connection
  // error and leaves a slot on screen that can never be booked.
  //
  // Read in THIS order (errors, the body, graphQLErrors, cause), kept from
  // before the c4 move; `entriesFrom` reads graphQLErrors before the body. A
  // non-2xx body that is not JSON tells us nothing: null, and the caller's
  // generic failure, which is honest.
  const codes = [
    ...entriesOf(candidate.errors),
    ...entriesOf(bodyErrorsOf(error)),
    ...entriesOf(candidate.graphQLErrors),
  ].map(({ code }) => code);
  codes.push(candidate.cause?.extensions?.code);
  for (const code of codes) {
    if (code === "SLOT_HELD" || code === "SLOT_TAKEN" || code === "NOT_FOUND") return code;
  }
  return null;
}
